import React from 'react';

import { CollectionAsset } from '@kaltura-ott/tvpil-shared';

import { Card, CardBubbleInfo, CardInner, CardTitle } from 'components/presenters';

import RecommendationCardContent from '../RecommendationCardContent/RecommendationCardContent';

import { useRecommendationCard } from './hooks/useRecommendationCard/useRecommendationCard';

interface Props {
  item: CollectionAsset;
  itemWidth: number;
  imageHeight: number;
}

function RecommendationCard({ item, itemWidth, imageHeight }: Props) {
  const {
    link,
    title,
    isAdult,
    isRecord,
    handleRef,
    ariaLabel,
    assetRating,
    channelName,
    clickHandler,
    onMouseEnter,
    onMouseLeave,
    handleLinkRef,
    isLinkAsAsset,
    isSeriesRecord,
    handleClickInfo,
    isDisplayRating,
    defaultImageUrl,
    backgroundImageUrl,
    collectionProgramAsset,
    isExternalProviderAsset,
  } = useRecommendationCard({ item, itemWidth, imageHeight });

  return (
    <Card
      handleLinkRef={handleLinkRef}
      clickHandler={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      link={link}
      imageHeight={imageHeight}
      itemWidth={itemWidth}
      isMosaicProgram={false}
      ariaLabel={ariaLabel}
    >
      <CardInner
        defaultImageUrl={defaultImageUrl}
        cardType='recommendation'
        url={backgroundImageUrl}
        name={title}
        handleRef={handleRef}
        handleLinkRef={handleLinkRef}
        isAdult={isAdult}
        isNoDataWithNoLogoImg={false}
        contentOverlay={
          <RecommendationCardContent
            isDisplayRating={isDisplayRating}
            assetRating={assetRating!}
            shouldDisplayPlayButton
          />
        }
      />
      <CardBubbleInfo
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        isExternalProviderAsset={isExternalProviderAsset}
        channelHasProgram
        channelName={channelName}
        isAdult={isAdult}
        title={title}
        isMosaicProgram={false}
        handleClickInfo={handleClickInfo}
        collectionProgramAsset={collectionProgramAsset}
        isLinkAsAsset={isLinkAsAsset}
      />
      <CardTitle
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        isAdult={isAdult}
        isStaticInfo
        title={title}
        isMosaicProgram={false}
      />
    </Card>
  );
}

export default RecommendationCard;
